// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MIlReAZLRfoixj2BDkp3{flex-direction:column;align-self:stretch;align-items:flex-start;gap:2px;width:100%;padding:24px 20px;display:flex;overflow:hidden}.vVUTXC3gBlAV5Im4CuXE{padding-top:8px;padding-bottom:8px}.BnntgofezbQOeHAubdaP{flex-grow:1;gap:2px;width:100%;display:grid;overflow:hidden}.A7zByH8tT6EUgvIaM1tg{align-items:center;gap:10px;height:40px;display:flex}.A7zByH8tT6EUgvIaM1tg .FUZNVsgkuqI5TSh2w6J2{cursor:pointer;align-items:center;height:100%;display:flex}.A7zByH8tT6EUgvIaM1tg:hover .WriZhFsUAcLoFH0v3oXZ{visibility:visible}.A7zByH8tT6EUgvIaM1tg .u3XQxVADTbQnHH1vYQwz,.A7zByH8tT6EUgvIaM1tg .WriZhFsUAcLoFH0v3oXZ{justify-content:center;align-items:center;gap:8px;width:32px;display:flex}.A7zByH8tT6EUgvIaM1tg .WriZhFsUAcLoFH0v3oXZ{visibility:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `MIlReAZLRfoixj2BDkp3`,
	"label": `vVUTXC3gBlAV5Im4CuXE`,
	"list": `BnntgofezbQOeHAubdaP`,
	"item": `A7zByH8tT6EUgvIaM1tg`,
	"title": `FUZNVsgkuqI5TSh2w6J2`,
	"close": `WriZhFsUAcLoFH0v3oXZ`,
	"box": `u3XQxVADTbQnHH1vYQwz`
};
export default ___CSS_LOADER_EXPORT___;
